import React, { useEffect, useRef, useState } from "react";
import "./NmdFooter.css";
import logo from "../../assets/images/nmd-logo.png";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedinIn} from "react-icons/fa";

const NmdFooter = () => {
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }
  }, []);

  return (
    <footer ref={footerRef} className={`nmd-footer ${isVisible ? "visible" : ""}`}>
      <div className="nmd-footer-container">

        {/* Left */}
        <div className="footer-left">
          <img src={logo} alt="NMD Infotech" className="footer-logo" />
          <p className="footer-text">
            Empowering Your Business Presence With Best Solutions – NMD Services!
          </p>
{/* 
          <div className="footer-socials">
  <a href="https://instagram.com/nmdinfotech" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>

  <a href="https://linkedin.com/company/nmd-pvt-ltd" target="_blank" rel="noopener noreferrer">
    <FaLinkedinIn />
  </a>
</div> */}
{/* Social Icons — Mobile Only */}
<div className="footer-socials mobile-footer-icons">
  <a href="https://instagram.com/nmdinfotech" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>
  
  <a href="https://in.linkedin.com/company/nmd-infotech" target="_blank" rel="noopener noreferrer">
    <FaLinkedinIn />
  </a>
</div>


        </div>

        {/* Services */}
        <div className="footer-column">
          <h3>Services</h3>
          <ul>
            <li><Link to="services/app-development">App Development</Link></li>
            <li><Link to="services/game-development">Game Development</Link></li>
            <li><Link to="services/data-science">Data Science</Link></li>
            <li><Link to="services/business-consulting">Business Consulting</Link></li>
            <li><Link to="services/data-analysis">Data Analysis</Link></li>
            <li><Link to="services/digital-marketing">Digital Marketing Services</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div className="footer-column">
          <h3>Company</h3>
          <ul>
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact Card */}
        <div className="footer-contact-card">
          <h3>Contact</h3>

          <div className="contact-item">
            <span>📞 Phone</span>
            <p><a href="tel:+919049442717">+91 9049442717</a></p>
          </div>

          <div className="contact-item">
            <span>✉️ Email</span>
            <p><a href="mailto:info@nmdinfotechservices.com">hr@nmdinfotechservices.com</a></p>
          </div>

          <div className="contact-item">
            <span>📍 Address 1:</span>
            <p>
              Office No.202, Mantri House, <br />
              Fergusson College Rd, Shivajinagar, <br />
              Pune, Maharashtra 411005
            </p>  <br />
            <span>📍 Address 2:</span>
            <p>Office No.11, Second Floor, NMD PVT LTD, Aditya Centeegra, Fergusson College Rd, Shivajinagar, Pune.

</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 NMD Infotech, All rights reserved.</p>

        <div className="footer-links">
          <Link to="/terms">Terms of Services</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default NmdFooter;
